import React, {Component} from 'react';
import './OptionsButton.css';

class OptionsButton extends Component {
	constructor() {
		super();

		this.state = {
			open: false
		};

		this.toggleOpen = e => {
			e.preventDefault();
			this.setState({open: !this.state.open});
		};
	}

	render() {
		const {className, options = []} = this.props;
		const {open} = this.state;

		return (
			<div
				className={`OptionsButton ${className || ''} ${open ? 'open' : ''}`}
				onClick={this.props.onClick}>
				<button onClick={this.toggleOpen}>
					<span className="OptionsButton-show icon icon-more_vert" />
					<span className="OptionsButton-hide icon icon-close" />
				</button>
				<ul>
					{options &&
						options
							.filter(option => !!option)
							.map(({key, icon, label, onSelect}) => (
								<li key={key} onClick={this.toggleOpen}>
									<button className="OptionsButton-item" onClick={onSelect}>
										{icon && <span className={`icon ${icon}`} />}
										<span className="OptionsButton-item-label">{label}</span>
									</button>
								</li>
							))}
				</ul>
			</div>
		);
	}
}

export default OptionsButton;



// WEBPACK FOOTER //
// ./src/widgets/OptionsButton.js